function e(e){return!!e}export{e as isTruthy};
//# sourceMappingURL=isTruthy-B_WAssz3.js.map